import { Disclosure } from '@headlessui/react';
import { Fragment } from 'react';
import { Button } from '../../../../../core/components/atoms/Button';
import { Icon } from '../../../../../core/components/atoms/Icon';
import { Typography } from '../../../../../core/components/molecules/Typography';
import { Modal } from '../../../../../core/components/templates/Modal';
import { useExerciseStore } from '../../../stores/exercisesStore';
import InnerCheckbox from './innerCheckbox';

interface IFilterModal {
  isOpen: boolean;
  onClose: () => void;
  subtitle: string;
  onSubmit: () => void;
}

export default function FilterModal({
  isOpen,
  onClose,
  subtitle,
  onSubmit,
}: IFilterModal) {
  const {
    favorite,
    difficulty,
    unanswered,
    rightAnswer,
    wrongAnswer,
    setFavorite,
    setDifficulty,
    setUnanswered,
    setRightAnswer,
    setWrongAnswer,
    setQuestionOptions,
    setIsEnem
  } = useExerciseStore();

  const difficultyHandler = (level: string) => {
    if (difficulty.indexOf(level) >= 0) {
      const array = [...difficulty];

      array.splice(difficulty.indexOf(level), 1);
      setDifficulty(array);
    } else {
      const array = [...difficulty];
      array.push(level);

      setDifficulty(array);
    }
  };

  // const questionHandler = (type: string) => {
  //   const aux = [...questionOptions];
  //   const idx = aux.find((it) => it === type);

  //   if(idx) {
  //     const newArray = aux.filter((it) => it !== type)
  //     setQuestionOptions(newArray);
  //   } else {
  //     aux.push(type);
  //     setQuestionOptions(aux);
  //   }
  // };

  const reset = () => {
    setFavorite(false);
    setUnanswered(false);
    setRightAnswer(false);
    setWrongAnswer(false);
    setDifficulty([]);
    setQuestionOptions([]);
    setIsEnem([])
  };

  const submit = () => {
    onSubmit();
    onClose();
  };

  return (
    <Modal
      position='top-right'
      size='md'
      isOpen={isOpen}
      onClose={() => onClose()}
      className='   
        m-0 
        mt-[10vh] 
        flex 
        min-h-[90vh]
        
        max-w-full 
        flex-col 
        rounded-b-none 
        md:m-4
        md:min-h-[calc(100%-2rem)]
    
        md:max-w-lg 
        md:rounded-b-lg'  
      title='Filtrar exercícios'
      subtitle={subtitle}
    >
      <div className='flex w-full flex-col gap-md overflow-x-auto px-4 py-5 xs:h-[45vh] lg:h-[75vh]'>
        <Disclosure defaultOpen>
          <Disclosure.Panel className='flex w-full flex-col gap-xl pb-3'>
            <InnerCheckbox
              onChange={() => setFavorite(!favorite)}
              label='Favoritados'
              checked={favorite}
              id='favorite'
              value={'favorite'}
            />
          </Disclosure.Panel>
        </Disclosure>
        <Disclosure defaultOpen>
          {({ open }) => (
            <Fragment>
              <Disclosure.Button className='flex w-full justify-between text-left'>
                <Typography size='h4' type='title' className='text-left'>
                  Resolução
                </Typography>
                <Icon
                  Icon='expand_more'
                  type='material'
                  className={`${open ? 'rotate-180 transform' : ''} h-5 w-5 text-mono-color-black`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className='mt-5 flex w-full flex-col gap-xl pb-3 pl-4'>
                <InnerCheckbox
                  onChange={() => setUnanswered(!unanswered)}
                  label='Não respondidos'
                  checked={unanswered}
                  id='resolution-notanswered'
                  value={'unanswered'}
                />
                <InnerCheckbox
                  onChange={() => setWrongAnswer(!wrongAnswer)}
                  label='Respostas erradas'
                  checked={wrongAnswer}
                  id='resolution-wrong'
                  value='wrongAnswer'
                />
                <InnerCheckbox
                  onChange={() => setRightAnswer(!rightAnswer)}
                  label='Respostas certas'
                  checked={rightAnswer}
                  id='resolution-right'
                  value='rightAnswer'
                />
              </Disclosure.Panel>
            </Fragment>
          )}
        </Disclosure>
        <Disclosure defaultOpen>
          {({ open }) => (
            <Fragment>
              <Disclosure.Button className='flex w-full justify-between text-left'>
                <Typography size='h4' type='title' className='text-left'>
                  Nível de dificuldade
                </Typography>
                <Icon
                  Icon='expand_more'
                  type='material'
                  className={`${open ? 'rotate-180 transform' : ''} h-5 w-5 text-mono-color-black`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className='mt-5 flex w-full flex-col gap-xl pb-3 pl-4'>
                <InnerCheckbox
                  onChange={() => difficultyHandler('easy')}
                  label='Fácil'
                  checked={difficulty.indexOf('easy') >= 0}
                  id='difficulty-easy'
                  value='easy'
                />
                <InnerCheckbox
                  onChange={() => difficultyHandler('medium')}
                  label='Médio'
                  checked={difficulty.indexOf('medium') >= 0}
                  id='difficulty-medium'
                  value='medium'
                />
                <InnerCheckbox
                  onChange={() => difficultyHandler('hard')}
                  label='Difícil'
                  checked={difficulty.indexOf('hard') >= 0}
                  id='difficulty-hard'
                  value='hard'
                />
                <InnerCheckbox
                  onChange={() => difficultyHandler('random')}
                  label='Aleatório'
                  checked={difficulty.indexOf('random') >= 0}
                  id='difficulty-random'
                  value='random'
                />
              </Disclosure.Panel>
            </Fragment>
          )}
        </Disclosure>
        {/* <Disclosure defaultOpen>
          {({ open }) => (
            <Fragment>
              <Disclosure.Button className='flex w-full justify-between text-left'>
                <Typography size='h4' type='title' className='text-left'>
                  Tipo de exercício
                </Typography>
                <Icon
                  Icon='expand_more'
                  type='material'
                  className={`${open ? 'rotate-180 transform' : ''} h-5 w-5 text-mono-color-black`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className='mt-5 flex w-full flex-col gap-xl pb-3 pl-4'>
                <InnerCheckbox
                  onChange={() => questionHandler('single_answer')}
                  label='Resposta única'
                  checked={questionOptions.indexOf('single_answer') >= 0}
                  id='type-single-answer'
                  value='single_answer'
                />
                <InnerCheckbox
                  onChange={() => questionHandler('multiple_answer')}
                  label='Resposta somatória'
                  checked={questionOptions.indexOf('multiple_answer') >= 0}
                  id='type-multiple-answer'
                  value='multiple_answer'
                />
                <InnerCheckbox
                  onChange={() => questionHandler('discursive')}
                  label='Resposta discursiva'
                  checked={questionOptions.indexOf('discursive') >= 0}
                  id='type-discursive'
                  value='discursive'
                />
              </Disclosure.Panel>
            </Fragment>
          )}
        </Disclosure> */}
      </div>
      <div className='fixed bottom-0 left-0 flex w-full flex-row items-center justify-center gap-lg px-4 py-5'>
        <Button
          variant='text'
          LeftIcon='delete'
          iconType='material'
          className='w-1/2'
          full
          onClick={() => reset()}
        >
          Limpar seleção
        </Button>
        <Button className='w-1/2' full onClick={() => submit()}>
          Aplicar filtros
        </Button>
      </div>
    </Modal>
  );
}
